import { apiRequest } from "./client";

/**
 * NestJS approval queue contract (Part 72 §72.5):
 * - GET  /api/approvals?status=&entityType=&entityId=
 * - GET  /api/ai/suggestions?status=&entityType=&entityId=
 * - POST /api/approvals/:id/approve | /reject
 * - POST /api/approvals/batch-approve (Sprint 14, Part 94 §94.1)
 * - POST /api/ai/suggestions/:id/undo
 */
export const approvalsApi = {
  list: async (params = {}) => {
    const query = new URLSearchParams();
    // Sprint 15 QA: "All" must actually send status=all — the backend
    // defaults to 'pending' when the param is missing.
    if (params.status) query.set("status", params.status);
    if (params.entityType) query.set("entityType", params.entityType);
    if (params.entityId) query.set("entityId", params.entityId);
    query.set("page", String(params.page ?? 1));
    query.set("size", String(params.size ?? 50));
    const data = await apiRequest(`/api/approvals?${query}`);
    return (data?.items || []).map((s) => ({ ...s }));
  },
  approve: (id) => apiRequest(`/api/approvals/${id}/approve`, { method: "POST" }),
  reject: (id) => apiRequest(`/api/approvals/${id}/reject`, { method: "POST" }),
  batchApprove: (ids) =>
    apiRequest("/api/approvals/batch-approve", {
      method: "POST",
      body: JSON.stringify({ ids }),
    }),
  undo: (id) => apiRequest(`/api/ai/suggestions/${id}/undo`, { method: "POST" }),
};
